import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";
import { services } from "../data/services";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContactForm({ defaultService = "" }) {
  const initial = { name: "", email: "", company: "", service: defaultService, message: "" };
  const [form, setForm] = useState(initial);
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill in your name, email and message.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Message sent! Our team will reach out shortly.");
      setForm(initial);
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-xl border border-white/10 bg-[#0d0e15] px-4 py-3.5 text-white placeholder:text-[#5a6478] outline-none transition-all focus:border-transparent focus:ring-2 focus:ring-[#b026ff]";

  return (
    <form onSubmit={submit} data-testid="contact-form" className="glass rounded-3xl p-8 md:p-10">
      <div className="grid gap-5 sm:grid-cols-2">
        <input
          data-testid="contact-name"
          className={inputCls}
          placeholder="Full name *"
          value={form.name}
          onChange={set("name")}
        />
        <input
          data-testid="contact-email"
          type="email"
          className={inputCls}
          placeholder="Email address *"
          value={form.email}
          onChange={set("email")}
        />
      </div>
      <input
        data-testid="contact-company"
        className={`${inputCls} mt-5`}
        placeholder="Company (optional)"
        value={form.company}
        onChange={set("company")}
      />
      <select
        data-testid="contact-service"
        className={`${inputCls} mt-5`}
        value={form.service}
        onChange={set("service")}
      >
        <option value="">Which service are you interested in?</option>
        {services.map((s) => (
          <option key={s.slug} value={s.title} className="bg-[#0d0e15]">
            {s.title}
          </option>
        ))}
      </select>
      <textarea
        data-testid="contact-message"
        rows={5}
        className={`${inputCls} mt-5 resize-none`}
        placeholder="Tell us about your project *"
        value={form.message}
        onChange={set("message")}
      />
      <button
        type="submit"
        disabled={loading}
        data-testid="contact-submit"
        className="mt-6 flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#00f0ff] to-[#b026ff] px-6 py-4 font-semibold text-[#05050a] transition-transform hover:scale-[1.02] disabled:opacity-60"
      >
        {loading ? (
          <Loader2 className="h-5 w-5 animate-spin" />
        ) : (
          <>
            Send message <Send className="h-4 w-4" />
          </>
        )}
      </button>
    </form>
  );
}
